export default "__VITE_ASSET__B3htrJ_a__"